import { useState } from "react";
import { Modal, Form, Input } from "antd";
import callApi from "../../constants/API/CallApi";
import { ShowToast, Severty } from "../../helper/toast";
import { addCity } from "../../constants/API/API";

const AddCity = ({ visible, setVisible, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleOk = async (values) => {
    setLoading(true);
    callApi({
      callback: addCity,
      payload: { ...values },
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        form.resetFields();
        refresh((x) => !x);
        setVisible(false);
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };


  return (
    <Modal
      open={visible}
      className="tab_modal"
      title="Add City"
      okText="Create"
      onCancel={handleCancel}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      width={500}
      destroyOnClose
    >
      <Form
        id="create"
        form={form}
        onFinish={handleOk}
        layout="vertical"
        preserve={false}
        initialValues={{
          isActive: true,
          isDeleted: false,
        }}
      >
        <Form.Item
          name="name"
          label="City Name"
          rules={[{ required: true, message: "City Name is required" }]}
          normalize={(v) => v?.trimStart()}
        >
          <Input placeholder="Enter City Name" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddCity;
